import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
import { format, subDays } from "date-fns";
import { JSConn } from "@/utilities/js-conn";
import { itemRouteBuilder, NamedRts } from "@/router";
import { WorkOrderEvent } from "@/store/modules/workOrders";

import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";

require("vue-simple-calendar/static/css/default.css");

export default defineComponent({
  name: "calendar",
  components: {
    LoadingAnimation,
    CalendarView,
    CalendarViewHeader,
  },

  setup(_props, ctx) {
    const $store = ctx.root.$store;

    const dataLoaded = ref(false);
    const loadingMessage =
      "Loading work orders...Dragging them in from the database...";

    const showDate = ref(new Date());
    const from_date = ref("");

    const calendarEvents = ref<WorkOrderEvent[]>([]);

    onMounted(() => {
      const fromDate = subDays(new Date(), 14);
      from_date.value = format(fromDate, "yyyy-MM-dd");

      loadScheduledWorkOrders().then(() => {
        dataLoaded.value = true;
      });
    });

    const workOrdersAsEvents = computed(() => {
      return $store.getters.workOrdersAsEvents as WorkOrderEvent[];
    });

    const setShowDate = (d: Date) => {
      showDate.value = d;
      from_date.value = format(subDays(d, 7), "yyyy-MM-dd");
      loadScheduledWorkOrders();
    };

    const loadScheduledWorkOrders = () => {
      const jsConnScheduledWorkOrders = new JSConn();

      jsConnScheduledWorkOrders.formParams = {
        scheduled_after_date: from_date.value,
      };

      const dataPromises = [
        $store.dispatch("needWorkOrders", jsConnScheduledWorkOrders),
      ];

      return Promise.all(dataPromises).then(() => {
        calendarEvents.value = [...workOrdersAsEvents.value];
        return Promise.resolve();
      });
    };

    const clickedEvent = (event: WorkOrderEvent) => {
      ctx.root.$router.push(
        itemRouteBuilder(NamedRts.workOrderTasks, event.id),
      );
    };

    const droppedOnDate = (event: WorkOrderEvent, date: Date) => {
      // update and get the data again
      const jsConn = new JSConn();
      jsConn.formParams = {
        id: event.id,
        scheduled_date: format(date, "yyyy-MM-dd"),
      };

      $store
        .dispatch("updateWorkOrder", jsConn)
        .then(() => {
          return loadScheduledWorkOrders();
        })
        .then(() => {
          dataLoaded.value = true;
        });
    };

    return {
      dataLoaded,
      loadingMessage,
      showDate,

      calendarEvents,
      from_date,

      workOrdersAsEvents,
      setShowDate,
      clickedEvent,
      droppedOnDate,
    };
  },
});
